import HttpRouter from "../services/HttpRouter";

export default {
    getSubjects ({schoolId, language}, successCallback) {
        HttpRouter.get(null, 'school/' + schoolId + '/subjects/available/' + (language ? language : '')).then(
            function (response) {
                var subjects = response.data.data;
                successCallback(subjects);
            },
            function (response) {
                console.error('Problem loading subjects', response);
            }
        );
    },

}
